import React, { useEffect, useState, useCallback } from "react";
import {
  Card,
  Table,
  Tag,
  Button,
  Space,
  Typography,
  Modal,
  Select,
  Input,
  DatePicker,
  Form,
  Tabs,
  Switch,
  InputNumber,
  Row,
  Col,
  Divider,
  Popconfirm,
} from "antd";
import {
  GiftOutlined,
  SettingOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import moment from "moment";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import useRequest from "../hooks/useRequest";
import { ShowToast, Severty } from "../helper/toast";
import DeleteConfirmationModal from "../components/DeleteConfirmationModal";

const { Title, Text } = Typography;
const { Search } = Input;
const { RangePicker } = DatePicker;
const { TabPane } = Tabs;

function ReferralCashbackManager() {
  const { request } = useRequest();
  const [activeTab, setActiveTab] = useState("campaign");
  const [campaignModal, setCampaignModal] = useState(false);
  const [form] = Form.useForm();

  const [campaigns, setCampaigns] = useState([]);

  const [selectedCampaignId, setSelectedCampaignId] = useState(null);

  const selectedCampaign = campaigns.find(
    (c) => c.id === selectedCampaignId
  );

  const [referralList, setReferralList] = useState([]);
  const [cashbackList, setCashbackList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeGrowthTab, setActiveGrowthTab] = useState("week");
  const [referralGrowthData, setReferralGrowthData] = useState();
  const [isEditMode, setIsEditMode] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [filters, setFilters] = useState({
    search: "",
    status: null,
    dateRange: null,
    service_type: null,
  });
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => {
      setFilters((prev) => ({ ...prev, search: searchTerm }));
    }, 500);
    return () => clearTimeout(timer);
  }, [searchTerm]);

  // -----------------------------
  // 🔥 MOCK DATA
  // -----------------------------

  const fetchCampaigns = () => {
    request({
      url: "/referrals/campaigns",
      method: "GET",
      onSuccess: (res) => {
        const data = res.data || [];
        setCampaigns(data);

        // if (data.length > 0) {
        //   setSelectedCampaignId(data[0].id);
        // }
      },
      onError: () => {
        setCampaigns([]);
      },
    });
  };

  useEffect(() => {
    fetchCampaigns();
  }, []);

  const fetchReferralData = () => {
    let url = "";
    if (activeTab === "referrals") {
      url = "/referrals/tracking";
    } else if (activeTab === "cashback") {
      url = "/referrals/cashbacks";
    } else {
      return;
    }

    if (filters.search) {
      url += `?search=${encodeURIComponent(filters.search)}`;
    }

    if (activeTab === "cashback" && filters.service_type) {
      url += url.includes("?") ? `&service_type=${filters.service_type}` : `?service_type=${filters.service_type}`;
    }

    setLoading(true);
    request({
      url: url,
      method: "GET",
      onSuccess: (res) => {
        const data = res.data || [];
        if (activeTab === "referrals") {
          setReferralList(data);
        } else if (activeTab === "cashback") {
          setCashbackList(data);
        }
        setLoading(false);
      },
      onError: () => {
        setReferralList([]);
        setCashbackList([]);
        setLoading(false);
      },
    });
  };

  useEffect(() => {
    fetchReferralData();
  }, [activeTab, filters.search, filters.service_type]);


  const mockReferrals = Array.from({ length: 60 }, (_, i) => ({
    id: i + 1,
    referrer: `User ${i + 1}`,
    referred: `User ${i + 100}`,
    referral_date: moment().subtract(i, "days"),
  }));

  const mockCashbacks = Array.from({ length: 45 }, (_, i) => ({
    id: i + 1,
    user: `User ${i + 1}`,
    transaction_id: `TXN${100000 + i}`,
    amount: selectedCampaign?.cashback_amount || 10,
    date: moment().subtract(i, "days"),
    status: ["Credited", "Failed", "Reversed"][i % 3],
  }));

  // -----------------------------
  // REFERRAL GROWTH DATA
  // -----------------------------


  const fetchReferralGrowthData = useCallback((campaignId, tab) => {
    console.log(campaignId, tab);
    request({
      url: `/api/admin/campaigns/${campaignId}`,
      method: "GET",
      onSuccess: (res) => {
        console.log(res.analytics[tab.toLowerCase()]);
        setReferralGrowthData(res.analytics[tab.toLowerCase()]);
      },
      onError: (err) => {
        setReferralGrowthData([]);
      },
    });
    // if (tab === "week") {
    //   setReferralGrowthData([
    //     { week: "Week 1", referrals: 20 },
    //     { week: "Week 2", referrals: 45 },
    //     { week: "Week 3", referrals: 60 },
    //     { week: "Week 4", referrals: 10 },
    //     { week: "Week 5", referrals: 120 },
    //     { week: "Week 6", referrals: 150 },
    //     { week: "Week 7", referrals: 150 },
    //   ]);
    // }
    //  else if (tab === "month") {
    //   setReferralGrowthData([
    //     { month: "Jan", referrals: 20 },
    //     { month: "Feb", referrals: 45 },
    //     { month: "Mar", referrals: 60 },
    //     { month: "Apr", referrals: 10 },
    //     { month: "May", referrals: 120 },
    //     { month: "Jun", referrals: 150 },
    //   ]);
    // } else if (tab === "year") {
    //   setReferralGrowthData([
    //     { year: "2019", referrals: 20 },
    //     { year: "2020", referrals: 45 },
    //     { year: "2021", referrals: 60 },
    //     { year: "2022", referrals: 10 },
    //     { year: "2023", referrals: 120 },
    //     { year: "2024", referrals: 150 },
    //     { year: "2025", referrals: 150 },
    //   ]);
    // };

    // request({
    //   url: `/referrals/growth?tab=${tab}`,
    //   method: "GET",
    //   onSuccess: (res) => {
    //     setReferralGrowthData(res.data);
    //   },
    //   onError: (err) => {
    //     setReferralGrowthData([]);
    //   },
    // });
  }, []);

  // useEffect(() => {
  //   fetchReferralGrowthData("week");
  // }, [selectedCampaignId]);

  // -----------------------------
  // FETCH MOCK
  // -----------------------------

  // const fetchData = useCallback(() => {
  //   setLoading(true);
  //   setTimeout(() => {
  //     setReferralList(mockReferrals);
  //     setCashbackList(mockCashbacks);
  //     setLoading(false);
  //   }, 500);
  // }, [selectedCampaignId]);

  // useEffect(() => {
  //   fetchData();
  // }, [fetchData]);

  // -----------------------------
  // TABLE COLUMNS
  // -----------------------------

  const referralColumns = [
    {
      title: "Referral Code",
      dataIndex: "referral_code",
      render: (code) => <Text code>{code}</Text>,
    },
    {
      title: "Referrer",
      key: "referrer",
      render: (_, record) =>
        record.referrer ? (
          <div>
            <div style={{ fontWeight: 500 }}>
              <Tag color="blue" style={{ marginLeft: 6 }}>
                {record.referrer_email}
              </Tag>
            </div>
            <div style={{ fontSize: 12, color: "#888" }}>
              {record.referrer_mobile}
            </div>
          </div>
        ) : "N/A"
    },
    {
      title: "Referred User",
      key: "referred",
      render: (_, record) =>
        record.referrer ? (
          <div>
            <div style={{ fontWeight: 500 }}>
              <Tag color="blue" style={{ marginLeft: 6 }}>
                {record.referred_user_email}
              </Tag>
            </div>
            <div style={{ fontSize: 12, color: "#888" }}>
              {record.referred_user_mobile}
            </div>
          </div>
        ) : "N/A"
    },
    {
      title: "Date",
      dataIndex: "referred_at",
      render: (d) => moment(d).format("DD MMM YYYY"),
    },
  ];

  const cashbackColumns = [
    {
      title: "User",
      key: "user",
      render: (_, record) =>
        record.user ? (
          <div>
            <div style={{ fontWeight: 500 }}>
              <div>  {record.user.first_name ?? ""} {record.user.middle_name ?? ""} {record.user.last_name ?? ""}</div>
              <Tag color="blue" style={{ marginLeft: 6 }}>
                {record.user.id}
              </Tag>
            </div>
          </div>
        ) : "N/A"
    },
    {
      title: "Transaction Id",
      dataIndex: "transaction_id",
    },
    {
      title: "Service Type",
      dataIndex: "service_type",
    },
    // {
    //   title: "Transaction ID",
    //   dataIndex: "transaction_id",
    //   key: "transaction_id",
    //   render: (transaction_id) => {
    //     if (!transaction_id) return "N/A";

    //     const shortId = `${transaction_id.slice(0, 6)}...${transaction_id.slice(-4)}`;

    //     return (
    //       <Tooltip title={transaction_id}>
    //         <span
    //           style={{
    //             cursor: "pointer",
    //             fontFamily: "monospace",
    //             color: "#1677ff",
    //           }}
    //         >
    //           {shortId}
    //         </span>
    //       </Tooltip>
    //     );
    //   },
    // },
    {
      title: "Amount",
      render: (_, r) => (
        <Text strong>
          {r.amount} {selectedCampaign?.currency}
        </Text>
      ),
    },
    {
      title: "Date",
      dataIndex: "date",
      render: (d) => moment(d).format("DD MMM YYYY"),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (status) => {
        const colors = {
          SUCCESS: "green",
          Credited: "green",
          Failed: "red",
          Reversed: "volcano",
        };
        return <Tag color={colors[status]}>{status}</Tag>;
      },
    },
    {
      title: "Source",
      dataIndex: "source",
    },
    ,
    {
      title: "Date",
      dataIndex: "created_at",
      render: (d) => moment(d).format("DD MMM YYYY"),
    },
  ];

  // -----------------------------
  // CREATE CAMPAIGN
  // -----------------------------

  const handleCreateCampaign = (values) => {
    if (isEditMode) {
      request({
        url: `/referrals/campaigns/${selectedCampaignId}`,
        method: "PUT",
        data: values,
        onSuccess: () => {
          setCampaignModal(false);
          form.resetFields();
          fetchCampaigns();
        },
        onError: () => {
          ShowToast("Failed to update campaign", Severty.ERROR);
        },
      });
    } else {
      request({
        url: "/referrals/campaigns",
        method: "POST",
        data: values,
        onSuccess: (res) => {
          setCampaignModal(false);
          form.resetFields();
          fetchCampaigns();
        },
      });
    };
  }

  const updateCampaignStatus = (checked) => {
    if (!selectedCampaignId) return;

    request({
      url: `/referrals/campaigns/${selectedCampaignId}`,
      method: "PUT",
      data: {
        is_active: checked,
      },
      onSuccess: () => {
        setCampaigns((prev) =>
          prev.map((c) =>
            c.id === selectedCampaignId
              ? { ...c, is_active: checked }
              : c
          )
        );
      },
    });
  };

  const handleDeleteCampaign = () => {
    setDeleting(true);
    request({
      url: `/referrals/campaigns/${selectedCampaignId}`,
      method: "DELETE",
      onSuccess: () => {
        ShowToast("Campaign deleted successfully", Severty.SUCCESS);
        setSelectedCampaignId(null);
        setCampaignModal(false);
        form.resetFields();
        fetchCampaigns();
        setDeleting(false);
      },
      onError: () => {
        ShowToast("Failed to delete campaign", Severty.ERROR);
        setDeleting(false);
      },
    });
  };

  const handleEditCampaign = () => {
    if (!selectedCampaign) return;

    setIsEditMode(true);
    setCampaignModal(true);

    form.setFieldsValue({
      name: selectedCampaign.name,
      description: selectedCampaign.description,
      cashback_amount: selectedCampaign.cashback_amount,
      min_transaction_amount: selectedCampaign.min_transaction_amount,
      currency: selectedCampaign.currency,
      eligibility_rule: selectedCampaign.eligibility_rule,
      reward_credit_delay_days: selectedCampaign.reward_credit_delay_days,
    });
  }


  return (
    <div>
      <Card
        title={
          <>
            <GiftOutlined /> Referral & Cashback Management
          </>
        }
      >
        <Tabs activeKey={activeTab} onChange={(key) => {
          setActiveTab(key);
          setSearchTerm("");
        }}>
          {/* CAMPAIGN TAB */}
          <TabPane tab="Campaign Settings" key="campaign">
            <Space style={{ marginBottom: 20, flexWrap: "wrap", gap: "10px" }}>
              <Select
                value={selectedCampaignId}
                placeholder={campaigns.length > 0 ? "Select campaign" : "No campaigns available"}
                style={{ width: 250 }}
                onChange={(value) => {
                  setSelectedCampaignId(value)
                  fetchReferralGrowthData(value, "week");
                }
                }
              >
                {campaigns.length > 0 && campaigns.map((c) => (
                  <Select.Option key={c.id} value={c.id}>
                    {c.name} ({c.cashback_amount} {c.currency} | Min: {c.min_transaction_amount || 0})
                  </Select.Option>
                ))}
              </Select>

              <Button
                icon={<PlusOutlined />}
                onClick={() => setCampaignModal(true)}
              >
                Add Campaign
              </Button>
              {selectedCampaignId && <Button
                // icon={<PlusOutlined />}
                onClick={() => handleEditCampaign()}
              >
                Edit Campaign
              </Button>}
              {selectedCampaignId && (

                <Button danger loading={deleting} onClick={() => setDeleting(true)}>
                  Delete Campaign
                </Button>

              )}

              <DeleteConfirmationModal
                visible={deleting}
                key={selectedCampaignId || "delete-modal"}
                onCancel={() => setDeleting(false)}
                onConfirm={(reason) => {
                  handleDeleteCampaign(reason);
                  setDeleting(false);
                }}
                title={"Delete Campaign"}
                message={"Are you sure you want to delete this campaign ?"}
                itemName={selectedCampaign?.name || selectedCampaign?.fullName}
                // loading={deleting}
                okText={"Delete"}
                cancelText={"Cancel"}
                input={true}
              />
            </Space>

            <Row gutter={[16, 16]}>
              <Col span={24} md={12} xl={8}>
                <Card>
                  <Title level={5}>Status</Title>
                  <Switch
                    checked={selectedCampaignId && selectedCampaign?.is_active}
                    onChange={updateCampaignStatus}
                  />
                  <div style={{ marginTop: 10 }}>
                    {selectedCampaign?.is_active ? (
                      <Tag color="green">Active</Tag>
                    ) : (
                      <Tag color="red">Inactive</Tag>
                    )}
                  </div>
                </Card>
              </Col>

              <Col span={24} md={12} xl={8}>
                <Card>
                  <Title level={5}>Cashback</Title>
                  <Text strong>
                    {selectedCampaign?.cashback_amount}{" "}
                    {selectedCampaign?.currency}
                  </Text>
                  {selectedCampaign?.min_transaction_amount > 0 && (
                    <div style={{ marginTop: 8 }}>
                      <Text type="secondary">
                        Min Transaction: {selectedCampaign?.min_transaction_amount} {selectedCampaign?.currency}
                      </Text>
                    </div>
                  )}
                  {selectedCampaign?.reward_credit_delay_days > 0 && (
                    <div style={{ marginTop: 8 }}>
                      <Text type="secondary">
                        Delay: {selectedCampaign?.reward_credit_delay_days} Days
                      </Text>
                    </div>
                  )}
                </Card>
              </Col>

              <Col span={24} md={12} xl={8}>
                <Card>
                  <Title level={5}>Eligibility</Title>

                  {(() => {
                    const map = {
                      registration: { label: "On Registration", color: "blue" },
                      first_transaction: { label: "First Transaction", color: "green" },
                      kyc: { label: "KYC Completion", color: "purple" },
                    };

                    const rule = map[selectedCampaign?.eligibility_rule];

                    return rule ? (
                      <Tag color={rule.color}>{rule.label}</Tag>
                    ) : (
                      <Text type="secondary">Not defined</Text>
                    );
                  })()}
                </Card>
              </Col>
            </Row>

            <Divider />
            <Tabs
              activeKey={activeGrowthTab}
              disabled={!selectedCampaignId}
              onChange={(key) => {
                if (!selectedCampaignId) return;
                setActiveGrowthTab(key);
                console.log(selectedCampaign.id);
                console.log(typeof selectedCampaign.id);
                fetchReferralGrowthData(selectedCampaign.id, key);
              }}
              items={[
                { key: "week", label: "Week" },
                { key: "month", label: "Month" },
                { key: "year", label: "Year" },
              ]}
            />
            <Card>
              <Title level={5}>
                Referral Growth ({activeGrowthTab.toUpperCase()})
              </Title>

              <ResponsiveContainer width="100%" height={300}>
                <LineChart data={referralGrowthData}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey={activeGrowthTab} />
                  <YAxis />
                  <Tooltip />
                  <Line
                    type="monotone"
                    dataKey="referrals"
                    stroke="#1890ff"
                    strokeWidth={3}
                  />
                </LineChart>
              </ResponsiveContainer>
            </Card>
          </TabPane>
          {/* <div className="table-responsive"> */}
          {/* REFERRALS TAB */}
          <TabPane tab="Referral Tracking" key="referrals">
            <div style={{ marginBottom: 16 }}>
              <Input.Search
                placeholder="Search by email, mobile, referral code"
                allowClear
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{ width: 300 }}
              />
            </div>
            <Table
              className="table-responsive"
              columns={referralColumns}
              dataSource={referralList}
              rowKey="id"
              loading={loading}
              pagination={{ pageSize: 10 }}
            />
          </TabPane>

          {/* CASHBACK TAB */}
          <TabPane tab="Cashback Transactions" key="cashback">
            <div style={{ marginBottom: 16, display: "flex", gap: "16px" }}>
              <Input.Search
                placeholder="Search by name, transaction id, email, mobile"
                allowClear
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{ width: 350 }}
              />
              <Select
                placeholder="Filter by Service Type"
                allowClear
                style={{ width: 200 }}
                value={filters.service_type}
                onChange={(val) => setFilters((prev) => ({ ...prev, service_type: val }))}
              >
                <Select.Option value="REFERRAL">Referral</Select.Option>
                <Select.Option value="CASHBACK">Cashback</Select.Option>
              </Select>
            </div>
            <Table
              className="table-responsive"
              columns={cashbackColumns}
              dataSource={cashbackList}
              rowKey="id"
              loading={loading}
              pagination={{ pageSize: 10 }}
            />
          </TabPane>
          {/* </div> */}
        </Tabs>
      </Card>

      {/* CREATE CAMPAIGN MODAL */}
      <Modal
        title="Create New Campaign"
        open={campaignModal}
        onCancel={() => setCampaignModal(false)}
        footer={null}
      >
        <Form
          layout="vertical"
          form={form}
          onFinish={handleCreateCampaign}
        >
          <Form.Item
            name="name"
            label="Campaign Name"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="description"
            label="Campaign Description"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="cashback_amount"
            label="Cashback Amount"
            rules={[{ required: true }]}
          >
            <InputNumber style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item
            name="min_transaction_amount"
            label="Min Transaction Amount"
            initialValue={0}
          >
            <InputNumber style={{ width: "100%" }} min={0} />
          </Form.Item>

          <Form.Item
            name="currency"
            label="Currency"
            initialValue="NZ$"
          >
            <Input disabled />
          </Form.Item>

          <Form.Item
            name="eligibility_rule"
            label="Eligibility Rule"
          >
            <Select>
              <Select.Option value="registration">
                On Registration
              </Select.Option>
              <Select.Option value="first_transaction">
                On First Transaction
              </Select.Option>
              <Select.Option value="kyc">
                On KYC Completion
              </Select.Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="reward_credit_delay_days"
            label="Reward Delay (Days)"
            initialValue={0}
            rules={[{ required: true, message: 'Please set the delay duration' }]}
          >
            <InputNumber style={{ width: "100%" }} min={0} step={0.01} />
          </Form.Item>

          <Button type="primary" htmlType="submit">
            {isEditMode ? "Update Campaign" : "Create Campaign"}
          </Button>
        </Form>
      </Modal>
    </div>
  );
}
export default ReferralCashbackManager;
